
import bytes from 'bytes';

export const MAX_UPLOAD_SIZE = bytes('30MB');
export const GENERIC_UPLOAD_ERROR = 'There was an error uploading your file.';
export const MAX_UPLOAD_COUNT = 20;



// WEBPACK FOOTER //
// ./src/constants/images.js